var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 172,
    viewBox: "0 0 139 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.0005,
    y: 33,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_513)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3965 132.935V132.444L41.5045 132.215L41.3788 132.375V125.51L41.5388 125.716L40.3965 125.51V125.019L42.3041 124.962H45.9251L45.9366 126.778H45.3654L45.1598 125.533L45.354 125.659H42.1442L42.3155 125.487V128.766L42.1442 128.606H45.0799V129.303H42.1442L42.3155 129.143V132.375L42.1784 132.215L43.5492 132.444V132.935H40.3965Z",
    fill: "url(#paint1_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3114 132.353L48.2086 132.227L49.2023 132.444V132.935H46.5065V132.444L47.5003 132.227L47.3975 132.353V127.532L47.4889 127.635L46.5065 127.429V126.938L48.3114 126.87V132.353ZM47.7859 125.636C47.6108 125.636 47.4661 125.579 47.3518 125.465C47.2376 125.35 47.1805 125.194 47.1805 124.996C47.1805 124.791 47.2376 124.634 47.3518 124.528C47.4737 124.414 47.6222 124.357 47.7973 124.357C47.9801 124.357 48.1286 124.41 48.2428 124.516C48.3571 124.623 48.4142 124.783 48.4142 124.996C48.4142 125.202 48.3532 125.362 48.2314 125.476C48.1096 125.583 47.9611 125.636 47.7859 125.636Z",
    fill: "url(#paint2_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9307 133.038C51.5347 133.038 51.2225 132.916 50.994 132.672C50.7656 132.421 50.6513 132.044 50.6513 131.541V127.395L50.7998 127.543H49.6233V127.041L50.8113 126.87L50.6513 127.052V125.544L51.5652 125.396V127.052L51.4395 126.904H53.2329L53.1986 127.543H51.4395L51.5652 127.395V131.416C51.5652 131.736 51.6261 131.968 51.7479 132.113C51.8774 132.257 52.0564 132.33 52.2848 132.33C52.4219 132.33 52.5704 132.307 52.7303 132.261C52.8902 132.215 53.0616 132.151 53.2443 132.067L53.4385 132.592C52.8978 132.889 52.3952 133.038 51.9307 133.038Z",
    fill: "url(#paint3_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0474 132.935V132.444L55.0755 132.215L54.9384 132.387V127.475L55.0755 127.646L54.0474 127.429V126.938L55.6466 126.858L55.7723 127.978L55.6466 127.932C56.0274 127.543 56.4234 127.258 56.8346 127.075C57.2534 126.892 57.6494 126.801 58.0226 126.801C58.5252 126.801 58.9402 126.957 59.2677 127.269C59.6027 127.574 59.7665 128.05 59.7588 128.697V132.387L59.6446 132.227L60.6498 132.444V132.935H57.9883V132.444L58.9821 132.227L58.845 132.398V128.891C58.845 128.419 58.7384 128.073 58.5252 127.852C58.3119 127.631 58.0264 127.521 57.6685 127.521C57.3867 127.521 57.0783 127.597 56.7432 127.749C56.4158 127.901 56.0921 128.137 55.7723 128.457L55.8522 128.275V132.398L55.738 132.238L56.7089 132.444V132.935H54.0474Z",
    fill: "url(#paint4_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9946 133.038C63.4844 133.038 63.0312 132.924 62.6353 132.695C62.2469 132.459 61.9423 132.116 61.7214 131.667C61.5006 131.218 61.3902 130.67 61.3902 130.022C61.3902 129.36 61.5044 128.789 61.7329 128.309C61.9613 127.829 62.285 127.46 62.7038 127.201C63.1226 126.934 63.6138 126.801 64.1773 126.801C64.7104 126.801 65.1483 126.915 65.491 127.144C65.8413 127.365 66.1002 127.673 66.2677 128.069C66.4429 128.465 66.5305 128.918 66.5305 129.428C66.5305 129.512 66.5266 129.596 66.519 129.68C66.5114 129.763 66.5 129.866 66.4848 129.988H62.087V129.337H65.6852L65.5824 129.405C65.59 129.063 65.5481 128.747 65.4567 128.457C65.3653 128.168 65.2092 127.936 64.9884 127.761C64.7675 127.585 64.4743 127.498 64.1088 127.498C63.7204 127.498 63.393 127.601 63.1264 127.806C62.8599 128.012 62.6619 128.294 62.5325 128.652C62.403 129.009 62.3383 129.424 62.3383 129.897C62.3383 130.399 62.4106 130.833 62.5553 131.199C62.7 131.557 62.9094 131.835 63.1836 132.033C63.4653 132.231 63.808 132.33 64.2116 132.33C64.4934 132.33 64.8018 132.276 65.1369 132.17C65.4719 132.056 65.8184 131.884 66.1763 131.656L66.5076 132.17C66.0812 132.459 65.6547 132.676 65.2282 132.821C64.8018 132.966 64.3906 133.038 63.9946 133.038Z",
    fill: "url(#paint5_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6765 128.366C68.6765 128.61 68.7565 128.8 68.9164 128.937C69.0763 129.074 69.2819 129.188 69.5332 129.28C69.7845 129.364 70.0511 129.447 70.3328 129.531C70.6146 129.615 70.8811 129.718 71.1324 129.839C71.3837 129.961 71.5893 130.129 71.7493 130.342C71.9092 130.555 71.9891 130.837 71.9891 131.187C71.9891 131.591 71.8787 131.93 71.6579 132.204C71.437 132.478 71.1362 132.688 70.7555 132.832C70.3823 132.969 69.9635 133.038 69.499 133.038C69.2172 133.038 68.9278 133.015 68.6308 132.969C68.3338 132.924 68.0292 132.859 67.717 132.775L67.797 131.245H68.3795L68.4938 132.364L68.3909 132.238C68.5661 132.284 68.7565 132.322 68.9621 132.353C69.1677 132.383 69.3581 132.398 69.5332 132.398C69.8074 132.398 70.0587 132.36 70.2871 132.284C70.5232 132.2 70.7136 132.082 70.8583 131.93C71.003 131.77 71.0753 131.572 71.0753 131.336C71.0753 131.085 70.9954 130.887 70.8354 130.742C70.6831 130.597 70.4813 130.479 70.23 130.388C69.9787 130.296 69.7122 130.213 69.4304 130.136C69.1563 130.053 68.8936 129.95 68.6422 129.828C68.3909 129.699 68.1853 129.531 68.0254 129.325C67.8655 129.12 67.7855 128.838 67.7855 128.48C67.7855 128.092 67.8845 127.776 68.0825 127.532C68.2881 127.281 68.5547 127.098 68.8821 126.984C69.2172 126.862 69.5751 126.801 69.9559 126.801C70.2148 126.801 70.5004 126.828 70.8126 126.881C71.1248 126.934 71.4447 127.014 71.7721 127.121L71.715 128.412H71.1324L70.9611 127.464L71.0982 127.623C70.7022 127.509 70.329 127.452 69.9787 127.452C69.6056 127.452 69.2934 127.532 69.042 127.692C68.7984 127.844 68.6765 128.069 68.6765 128.366Z",
    fill: "url(#paint6_linear_402_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1314 128.366C74.1314 128.61 74.2113 128.8 74.3713 128.937C74.5312 129.074 74.7368 129.188 74.9881 129.28C75.2394 129.364 75.5059 129.447 75.7877 129.531C76.0694 129.615 76.336 129.718 76.5873 129.839C76.8386 129.961 77.0442 130.129 77.2041 130.342C77.364 130.555 77.444 130.837 77.444 131.187C77.444 131.591 77.3336 131.93 77.1127 132.204C76.8919 132.478 76.5911 132.688 76.2103 132.832C75.8372 132.969 75.4183 133.038 74.9538 133.038C74.6721 133.038 74.3827 133.015 74.0857 132.969C73.7887 132.924 73.4841 132.859 73.1719 132.775L73.2518 131.245H73.8344L73.9486 132.364L73.8458 132.238C74.021 132.284 74.2113 132.322 74.4169 132.353C74.6226 132.383 74.8129 132.398 74.9881 132.398C75.2622 132.398 75.5135 132.36 75.742 132.284C75.9781 132.2 76.1684 132.082 76.3131 131.93C76.4578 131.77 76.5302 131.572 76.5302 131.336C76.5302 131.085 76.4502 130.887 76.2903 130.742C76.138 130.597 75.9362 130.479 75.6849 130.388C75.4336 130.296 75.167 130.213 74.8853 130.136C74.6111 130.053 74.3484 129.95 74.0971 129.828C73.8458 129.699 73.6402 129.531 73.4803 129.325C73.3204 129.12 73.2404 128.838 73.2404 128.48C73.2404 128.092 73.3394 127.776 73.5374 127.532C73.743 127.281 74.0095 127.098 74.337 126.984C74.6721 126.862 75.03 126.801 75.4107 126.801C75.6697 126.801 75.9552 126.828 76.2674 126.881C76.5797 126.934 76.8995 127.014 77.227 127.121L77.1699 128.412H76.5873L76.4159 127.464L76.553 127.623C76.157 127.509 75.7839 127.452 75.4336 127.452C75.0604 127.452 74.7482 127.532 74.4969 127.692C74.2532 127.844 74.1314 128.069 74.1314 128.366Z",
    fill: "url(#paint7_linear_402_513)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1186 81.5017C37.6228 81.5017 36.3989 80.2779 36.3989 78.782V69.7163C36.3989 68.2204 37.6228 66.9966 39.1186 66.9966C40.6145 66.9966 41.8383 68.2204 41.8383 69.7163V78.782C41.8384 80.2779 40.6145 81.5017 39.1186 81.5017Z",
    fill: "#38454F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6509 84.2214C42.155 84.2214 40.9312 82.9976 40.9312 81.5017V66.9966C40.9312 65.5007 42.155 64.2769 43.6509 64.2769C45.1467 64.2769 46.3706 65.5007 46.3706 66.9966V81.5017C46.3706 82.9976 45.1467 84.2214 43.6509 84.2214Z",
    fill: "#546A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6338 66.9966C84.1296 66.9966 85.3535 68.2204 85.3535 69.7163V78.782C85.3535 80.2779 84.1296 81.5017 82.6338 81.5017C81.1379 81.5017 79.9141 80.2779 79.9141 78.782V69.7163C79.914 68.2204 81.1379 66.9966 82.6338 66.9966Z",
    fill: "#38454F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1001 64.2769C79.5959 64.2769 80.8198 65.5007 80.8198 66.9966V81.5017C80.8198 82.9976 79.5959 84.2214 78.1001 84.2214C76.6042 84.2214 75.3804 82.9976 75.3804 81.5017V66.9967C75.3804 65.5008 76.6042 64.2769 78.1001 64.2769Z",
    fill: "#546A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9038 78.7826H70.8485V69.7168H50.9038V78.7826Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1836 86.9414C46.6877 86.9414 45.4639 85.7176 45.4639 84.2217V64.2771C45.4639 62.7812 46.6877 61.5574 48.1836 61.5574C49.6794 61.5574 50.9033 62.7812 50.9033 64.2771V84.2217C50.9033 85.7175 49.6794 86.9414 48.1836 86.9414Z",
    fill: "#38454F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5683 61.5571C75.0642 61.5571 76.288 62.781 76.288 64.2768V84.2215C76.288 85.7173 75.0642 86.9412 73.5683 86.9412C72.0725 86.9412 70.8486 85.7173 70.8486 84.2215V64.2768C70.8485 62.781 72.0725 61.5571 73.5683 61.5571Z",
    fill: "#38454F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1559 70.6229C58.1559 70.1224 57.7498 69.7163 57.2493 69.7163C56.7489 69.7163 56.3428 70.1224 56.3428 70.6229C56.3428 71.1233 56.7489 71.5294 57.2493 71.5294C57.7498 71.5294 58.1559 71.1233 58.1559 70.6229Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7824 70.6231C61.7824 70.1227 61.3763 69.7166 60.8758 69.7166C60.3753 69.7166 59.9692 70.1227 59.9692 70.6231C59.9692 71.1236 60.3753 71.5297 60.8758 71.5297C61.3762 71.5297 61.7824 71.1236 61.7824 70.6231Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4088 70.6231C65.4088 70.1227 65.0027 69.7166 64.5023 69.7166C64.0018 69.7166 63.5957 70.1227 63.5957 70.6231C63.5957 71.1236 64.0018 71.5297 64.5023 71.5297C65.0027 71.5297 65.4088 71.1236 65.4088 70.6231Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9689 72.4361C59.9689 71.9356 59.5628 71.5295 59.0623 71.5295C58.5619 71.5295 58.1558 71.9356 58.1558 72.4361C58.1558 72.9366 58.5619 73.3427 59.0623 73.3427C59.5628 73.3427 59.9689 72.9366 59.9689 72.4361Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5958 72.4361C63.5958 71.9356 63.1896 71.5295 62.6893 71.5295C62.1889 71.5295 61.7827 71.9356 61.7827 72.4361C61.7827 72.9366 62.1888 73.3427 62.6893 73.3427C63.1897 73.3427 63.5958 72.9366 63.5958 72.4361Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1559 74.2493C58.1559 73.7489 57.7498 73.3428 57.2493 73.3428C56.7489 73.3428 56.3428 73.7489 56.3428 74.2493C56.3428 74.7498 56.7489 75.1559 57.2493 75.1559C57.7498 75.156 58.1559 74.7498 58.1559 74.2493Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7824 74.2493C61.7824 73.7489 61.3763 73.3428 60.8758 73.3428C60.3753 73.3428 59.9692 73.7489 59.9692 74.2493C59.9692 74.7498 60.3753 75.1559 60.8758 75.1559C61.3762 75.156 61.7824 74.7498 61.7824 74.2493Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4088 74.2493C65.4088 73.7489 65.0027 73.3428 64.5023 73.3428C64.0018 73.3428 63.5957 73.7489 63.5957 74.2493C63.5957 74.7498 64.0018 75.1559 64.5023 75.1559C65.0027 75.1559 65.4088 74.7498 65.4088 74.2493Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1559 77.8756C58.1559 77.3751 57.7498 76.969 57.2493 76.969C56.7489 76.969 56.3428 77.3751 56.3428 77.8756C56.3428 78.376 56.7489 78.7821 57.2493 78.7821C57.7498 78.7821 58.1559 78.3759 58.1559 77.8756Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7824 77.8756C61.7824 77.3751 61.3763 76.969 60.8758 76.969C60.3753 76.969 59.9692 77.3751 59.9692 77.8756C59.9692 78.376 60.3753 78.7821 60.8758 78.7821C61.3762 78.7821 61.7824 78.3759 61.7824 77.8756Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4088 77.8756C65.4088 77.3751 65.0027 76.969 64.5023 76.969C64.0018 76.969 63.5957 77.3751 63.5957 77.8756C63.5957 78.376 64.0018 78.7821 64.5023 78.7821C65.0027 78.7821 65.4088 78.3759 65.4088 77.8756Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9689 76.0626C59.9689 75.5621 59.5628 75.156 59.0623 75.156C58.5619 75.156 58.1558 75.5621 58.1558 76.0626C58.1558 76.563 58.5619 76.9691 59.0623 76.9691C59.5628 76.9691 59.9689 76.5629 59.9689 76.0626Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5958 76.0626C63.5958 75.5621 63.1896 75.156 62.6893 75.156C62.1889 75.156 61.7827 75.5621 61.7827 76.0626C61.7827 76.563 62.1888 76.9691 62.6893 76.9691C63.1897 76.9691 63.5958 76.5629 63.5958 76.0626Z",
    fill: "#ECF0F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_513",
    x: -16.6362,
    y: 0.363281,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_513",
    x: 7.75977,
    y: 94.9835,
    width: 102.321,
    height: 73.9548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_513",
    x: 3.76221,
    y: 32.1841,
    width: 114.228,
    height: 90.6577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.173802 0 0 0 0 0.598163 0 0 0 0 0.8875 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_513",
    x1: 60.876,
    y1: 33,
    x2: 60.876,
    y2: 139.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_513",
    x1: 30.0244,
    y1: 135.935,
    x2: 87.8677,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.40447946c71fbb96d01fe6fb2b76eb2d.svg";
export { ForwardRef as ReactComponent };